export default {

    getPopupFlag: (state) => (module) => {
        const module_type = module + '_cyo_popup'
        return state[module_type] !== undefined ? state[module_type] : null
    },
   
}